@if (mapItem(); as mapItem) {
    <ui-detail-view-container>
        <ui-detail-section>
            <ui-detail-image
                [imagePath]="mapItem.imagePath"
                [placeholderPath]="mapItem.placeholderPath"
                [altText]="mapItem.title"
            />
            <ui-detail-title [title]="mapItem.title"/>
            <ui-detail-address [text]="mapItem.address"/>
        </ui-detail-section>
        @if (mapItem.typeLabel) {
            <ui-detail-tags
                [tags]="[mapItem.typeLabel]"
            />
        }
        @if (mapItem.shortDescription) {
            <ui-detail-description
                [htmlDescription]="mapItem.shortDescription"
            />
        }
        @if (mapItem.administrationContact) {
            <ui-detail-description
                [title]="'Leitung und Kontakt'"
                [htmlDescription]="mapItem.administrationContact"
            />
        }
        @if (mapItem.specialFeatures) {
            <ui-detail-description
                [title]="mapItem.typeLabel === 'Berufsschule' ? 'Ausbildungsberufe' : 'Besonderheiten'"
                [htmlDescription]="mapItem.specialFeatures"
            />
        }
        @if (mapItem.careServices.length) {
            <ui-detail-factoid
                [title]="'Ganztagsbildungsangebot'"
                [data]="mapItem.careServices"
            />
        }
        @if (mapItem.unlinkedLanguages.length) {
            <ui-detail-factoid
                [title]="'Fremdsprachenangebot'"
                [data]="mapItem.unlinkedLanguages"
            />
        }
        @if (mapItem.educationalBranches.length) {
            <ui-detail-table
                [titleLeft]="mapItem.educationalBranchesLabel"
                [titleRight]="mapItem.doEducationalBranchesHaveLanguages ? 'Fremdsprachenangebot' : ''"
            >
                @for (branch of mapItem.educationalBranches; track $index) {
                    <ui-detail-table-row
                    >
                        <span class="educational-branch-name" left>
                          <ui-detail-tags [tags]="[branch.code]"/>
                            {{ branch.name }}
                        </span>
                        <ui-detail-tags
                            right
                            [rightAligned]="true"
                            [tags]="branch.languages"
                        />
                    </ui-detail-table-row>
                }
            </ui-detail-table>
        }
        @if (mapItem.measureGroups.length) {
            <ui-detail-section
                [title]="'Bildungsförderungsprogramm-Maßnahmen'"
            >
                @for (measureGroup of mapItem.measureGroups; track $index) {
                    <ui-school-map-item-measure-details
                        [measureGroup]="measureGroup"
                    />
                }
            </ui-detail-section>
        }
    </ui-detail-view-container>
}
